import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { cldImage } from "@/lib/cldImage";

const HERO = cldImage("https://images.unsplash.com/photo-1571877227200-a0d98ea607e9", { w: 1800 });

export default function ComingSoon() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setBusy(true);
    try {
      // Best-effort — the endpoint is optional; we don't want a 404 to block
      // the "we'll be in touch" experience. Silent-fail on 404/405.
      await api.post("/waitlist", { email }).catch(() => {});
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main data-testid="coming-soon-page" className="min-h-screen bg-ivory">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 md:py-20 grid md:grid-cols-12 gap-12 items-center min-h-[85vh]">
        <div className="md:col-span-6 order-2 md:order-1">
          <div className="label-xs text-espresso-light">Ghaziabad · Est. 2026</div>
          <h1 className="mt-6 font-serif text-5xl md:text-6xl lg:text-[5.5rem] leading-[0.95] tracking-tight text-espresso font-normal">
            Something<br/>
            <span className="italic text-espresso-light font-light">is layering.</span>
          </h1>
          <p className="mt-8 text-espresso-light max-w-md text-base leading-relaxed">
            TIRAMISÙ &amp; Co. is a boutique brand devoted to a single, obsessively-crafted dessert.
            We open our kitchen soon. Leave your email and we'll send you the first spoon.
          </p>

          {sent ? (
            <div
              className="mt-10 border border-gold/40 bg-gold/5 px-6 py-5 max-w-md"
              data-testid="coming-soon-thanks"
            >
              <p className="font-serif italic text-espresso">You're on the list.</p>
              <p className="text-sm text-espresso-light mt-1">We'll write to you the day we open — with a small welcome inside.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-10 flex flex-col sm:flex-row gap-3 max-w-md" data-testid="coming-soon-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                data-testid="coming-soon-email"
                className="flex-1 border border-line bg-transparent px-4 py-3 text-espresso placeholder:text-espresso-light/60 focus:outline-none focus:border-espresso"
              />
              <button
                type="submit"
                disabled={busy}
                data-testid="coming-soon-submit"
                className="btn-espresso disabled:opacity-40"
              >
                {busy ? "Sending…" : "Notify me"}
              </button>
            </form>
          )}

          <p className="mt-10 font-serif italic text-espresso-light text-lg">
            "One Spoon Closer to Happiness."
          </p>
        </div>

        <div className="md:col-span-6 order-1 md:order-2">
          <div className="aspect-[4/5] max-h-[720px] overflow-hidden bg-ivory-100">
            <img src={HERO} alt="Tiramisu, layered by hand" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </main>
  );
}
